import '@lottiefiles/lottie-player'
// eslint-disable
function StyledLoader() {
  return (
    <lottie-player
      autoplay
      loop
      style={{ width: '300px', height: '300px', margin: 'auto' }}
      src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
      speed="1"
    ></lottie-player>
  )
}

export default StyledLoader
